import DynamicTable from '@atlaskit/dynamic-table';
import { RowType } from '@atlaskit/dynamic-table/types';
import { Skeleton } from '@fuegokit/react';
import React from 'react';

import { JiraProject } from '../services/jira';
import { ProjectMapping, ProjectsMappings } from '../types';
import { TogglProjectExtended, TogglWorkspace } from '../types/toggl-api';
import { TogglProjectSelect } from './ToggleProjectSelect';

const head = {
  cells: [
    {
      key: 'key',
      content: 'Jira project key',
      width: 20,
    },
    {
      key: 'name',
      content: 'Jira project name',
      shouldTruncate: true,
      width: 50,
    },
    {
      key: 'toggle-project',
      content: 'Toggl project',
      width: 30,
    },
  ],
};

interface RowsData {
  isLoading: boolean;
  isDisabled: boolean;
  jiraProjects: JiraProject[];
  togglProjects: TogglProjectExtended[];
  workspaces: TogglWorkspace[];
  mappings: ProjectsMappings;
  onProjectSelect: (mappings: ProjectMapping) => Promise<void>;
}

export const generateRows = ({
  isLoading,
  jiraProjects,
  togglProjects,
  workspaces,
  mappings,
  onProjectSelect,
  isDisabled,
}: RowsData) => {
  return jiraProjects.map((jiraProject: JiraProject, index: number) => ({
    key: `row-${index}-${jiraProject.name}`,
    cells: [
      {
        key: 'key',
        content: <span>{jiraProject.key}</span>,
      },
      {
        key: 'name',
        content: <span>{jiraProject.name}</span>,
      },
      {
        key: 'toggl-project',
        content: isLoading ? (
          <Skeleton sx={{ margin: 0 }} height={40} width={290} />
        ) : (
          <TogglProjectSelect
            isDisabled={isDisabled}
            mappedTogglProjectId={mappings[jiraProject.key]}
            togglProjects={togglProjects}
            workspaces={workspaces}
            onProjectSelected={(togglProjectId) =>
              onProjectSelect({
                jiraProjectKey: jiraProject.key,
                togglProjectId,
              })
            }
          />
        ),
      },
    ],
  }));
};

export function ProjectsMappingTable({
  rows,
  loading,
}: {
  loading: boolean;
  rows: Array<RowType>;
}) {
  return <DynamicTable head={head} rows={rows} isLoading={loading} />;
}
